var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"app-qiniu__preview-audio"},[_c('audio',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"audio",attrs:{"src":_vm.src}}),_c('i',{staticClass:"iconfont icon-music"})])}
var staticRenderFns = []

export { render, staticRenderFns }